import { apiClient } from '@/services/api';

const state = () => ({
  palavras_bloqueadas: null,
});

const getters = {
  getterPalavrasBloqueadas: state => {
    return state.palavras_bloqueadas;
  },
};

const actions = {
  async getPalavrasBloqueadas({ commit }, payload) {
    const { cod_producao } = payload;
    try {
      const { data } = await apiClient.get(
        `/listarPalavrasBloqueadas/${cod_producao}`
      );

      commit('setPalavrasBloqueadas', data.palavras_bloqueadas);
    } catch (error) {
      return error;
    }
  },
}

const mutations = {
  setPalavrasBloqueadas(state, payload) {
    state.palavras_bloqueadas = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};